const basePath = (process.env.NEXT_PUBLIC_BASE_PATH || '').trim().replace(/\/+$/, '').toLowerCase();

export const normalizeConcurrencyPath = (asPath = '') => {
  const pathOnly = String(asPath).trim().split('?')[0].split('#')[0].toLowerCase();
  if (!pathOnly || pathOnly === '/') {
    return '/';
  }
  return pathOnly.endsWith('/') ? pathOnly : `${pathOnly}/`;
};

const buildIgnoreRoutes = (routes) => {
  const ignoreRoutes = new Set();

  routes.forEach((route) => {
    const normalizedRoute = normalizeConcurrencyPath(route);
    ignoreRoutes.add(normalizedRoute);
    if (basePath) {
      ignoreRoutes.add(normalizeConcurrencyPath(`${basePath}${normalizedRoute}`));
    }
  });

  return Array.from(ignoreRoutes);
};

const hubRoutes = [
  '/dashboard/my-communication-hub/',
  '/dashboard/accounthub/',
  '/dashboard/renewals/',
  '/quote/landing/',
];

export const ignoreRoutesHeartbeart = buildIgnoreRoutes(hubRoutes);

export const ignoreRoutesReleaseLock = buildIgnoreRoutes([
  '/dashboard/accounthub/',
  '/dashboard/renewals/',
  '/quote/landing/',
  '/dashboard/my-communication-hub/',
]);
